import Vue from 'vue';
import {
  HTTP
} from '@/http';
import AuthService from '@/services/AuthService';

let t = this;

export default class ProfileService {

  get() {
    return HTTP.get(`profile/` + AuthService.getUser().accountId);
  }
  getTradingFrequencyList() {
    return HTTP.get(`profile/list/en/tradingFrequency`);
  }
  getFinancialInstrumentsList() {
    return HTTP.get(`profile/list/en/financialInstruments`);
  }
  getExperienceList() {
    return HTTP.get(`profile/list/en/experience`);
  }
  getRiskToleranceList() {
    return HTTP.get(`profile/list/en/riskTolerance`);
  }
  getEducationList() {
    return HTTP.get(`profile/list/en/education`);
  }
  getCountryList() {
    return HTTP.get(`profile/list/en/country`);
  }
  save(profile) {
    return HTTP.put(`profile`, profile);
  }
  getDocuments() {
    return HTTP.get(`profile/documents`);
  }
  getStatus() {
    return HTTP.get(`profile/status`);
  }
  updateAvatar(imageName) {
    return HTTP.put(`profile/avatar?imageName=` + imageName);
  }
  addDocument(data) {
    return HTTP.post(`profile/documents`,
      data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/ProfileService.js